module.exports = new __parcel__URL__("logo_white.fa0f28c5.svg").toString();